import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1490.19336,0 1920,429.80664 1920,960 C1920,1490.19336 1490.19336,1920 960,1920 C429.80664,1920 0,1490.19336 0,960 C0,429.80664 429.80664,0 960,0 Z M950.162145,1342.68519 C865.69235,1342.68519 796.971403,1411.40613 796.971403,1495.87593 C796.971403,1580.34572 865.69235,1649.06667 950.162145,1649.06667 C1034.63194,1649.06667 1103.35289,1580.34572 1103.35289,1495.87593 C1103.35289,1411.40613 1034.63194,1342.68519 950.162145,1342.68519 Z M1153.65762,320 L746.666667,320 L845.784659,1218.62315 L1054.53963,1218.62315 L1153.65762,320 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconWarningSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconWarningSolid, _Component);

  var _super = _createSuper(IconWarningSolid);

  function IconWarningSolid() {
    _classCallCheck(this, IconWarningSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconWarningSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconWarning",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconWarningSolid.displayName = "IconWarningSolid";
  return IconWarningSolid;
}(Component);

IconWarningSolid.glyphName = 'warning';
IconWarningSolid.variant = 'Solid';
IconWarningSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconWarningSolid;
export { IconWarningSolid };